import type { PartnerFeatureFlag } from '@fukuri-admins/apis/client/gen/model';
import { isApiIntegration } from '~/utils/isApiIntegration';

type IConvertEnabledMenus = (
  featureFlags: PartnerFeatureFlag[] | undefined,
  isLoading?: boolean
) => {
  stressAssessment: boolean;
  clientNewsletter: boolean;
  userList: boolean;
  admins: boolean;
  branches: boolean;
};

/**
 * パートナー機能フラグ配列からサイドメニュー各項目の表示可否を算出する
 *
 * フラグ取得中（`isLoading` が true）の間は API 連携かどうかを判定できないため、
 * 制限対象メニュー（利用者一覧・企業管理者・事業所・ストレスチェック）を安全側で
 * 非表示にする（fail-closed）。suspense: false で取得する呼び出し元（ClientSideMenu）で、
 * フラグ確定前に隠すべきメニューが一瞬表示される flash を防ぐため。
 */
export const convertEnabledMenus: IConvertEnabledMenus = (featureFlags, isLoading = false) => {
  const apiIntegrationEnabled = isApiIntegration(featureFlags);
  // ロード中、または API 連携パートナーの場合は制限対象メニューを非表示にする
  const restrictMenus = isLoading || apiIntegrationEnabled;
  const isStressAssessmentEnabled =
    featureFlags?.find(flag => flag.feature_key === 'stress_assessment')?.enabled ?? false;

  return {
    stressAssessment: isStressAssessmentEnabled && !restrictMenus,
    clientNewsletter:
      featureFlags?.find(flag => flag.feature_key === 'client_newsletter')?.enabled ?? false,
    userList: !restrictMenus,
    admins: !restrictMenus,
    branches: !restrictMenus,
  };
};
